import { Outlet } from 'react-router-dom';

import { LegalLayout } from '@/features/legal';

export const LegalRootLayout = () => {
  return (
    <LegalLayout>
      <Outlet />
    </LegalLayout>
  );
};
